module.exports = __webpack_public_path__ + "img/mock-nolido-2-1285x1536.3a8892bf.png";